var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cardClass,on:{"click":_vm.handleClick}},[(_vm.image && _vm.image.src)?_c('nuxt-img',_vm._b({staticClass:"c-brand-card__image"},'nuxt-img',_vm.$getImgOptions(_vm.image),false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }